<template>

    <div class="header-wrapper pb-60">

        <header class="header">
            <div class="container header-inner">

                <router-link v-if="!loading" :to="{ name: 'home' }" class="logo" :aria-label="$brand">
                    <img v-if="!agency" src="/img/mgr-logo.svg" height="50" width="auto" :alt="$brand" />
                    <div v-else class="d-flex align-items-center">
                        <img v-if="agencyIcon" class="mr-10" :src="agencyIcon" height="30" width="auto" :alt="agencyName" />
                        <span>{{ agencyName }}</span>
                    </div>
                </router-link>
                <div v-else></div>

                <div v-if="apiKey && $route.name === 'setup'" class="d-flex align-items-center justify-content-end">
                    <v-dropdown-user logout-only />
                </div>

                <div v-else-if="apiKey && !['login', 'signup', 'mfa'].includes($route.name)" class="d-flex align-items-center justify-content-end">
                    <div class="nav">
                        <div class="nav-item">
                            <router-link class="nav-link accent" :to="{ name: 'dashboard' }">
                                <span>{{ $t('labels.dashboard') }}</span>
                            </router-link>
                        </div>
                    </div>
                </div>

                <div v-if="!apiKey && !agency" class="d-flex align-items-center justify-content-end">
                    <div class="nav">
                        <div class="nav-item d-flex">
                            <router-link class="nav-link" :class="{ active: $route.name === 'pricing' }" :to="{ name: 'pricing' }">
                                <span>{{ $t('labels.pricing') }}</span>
                            </router-link>
                        </div>
                        <div class="nav-item d-none d-md-flex">
                            <router-link class="nav-link" :class="{ active: $route.name === 'agencies' }" :to="{ name: 'agencies' }">
                                <span>{{ $t('labels.agencies') }}</span>
                            </router-link>
                        </div>
                        <div class="nav-item d-none d-md-flex">
                            <a class="nav-link" :href="$docsUrl" target="_blank" rel="noopener noreferrer">
                                <span>{{ $t('labels.docs') }}</span>
                            </a>
                        </div>
                        <div class="nav-item d-none d-md-flex">
                            <router-link class="nav-link" :class="{ active: $route.name === 'login' }" :to="{ name: 'login' }">
                                <span>{{ $t('labels.log_in') }}</span>
                            </router-link>
                        </div>
                        <div class="nav-item d-none d-md-flex">
                            <a class="nav-link soft" :href="$demoUrl" target="_blank" rel="noopener noreferrer">
                                <span>{{ $t('labels.book_a_demo') }}</span>
                            </a>
                        </div>
                        <div class="nav-item d-none d-md-flex">
                            <router-link class="nav-link accent" :to="{ name: 'signup' }">
                                <span>{{ $t('labels.get_started') }}</span>
                            </router-link>
                        </div>
                        <div class="nav-item">
                            <v-dropdown-lang />
                        </div>
                    </div>
                    <v-hamburger v-if="!apiKey && !agency">
                        <router-link class="dropdown-item" :to="{ name: 'signup' }">
                            <i class="fas fa-rocket" aria-hidden="true" />{{ $t('labels.get_started') }}
                        </router-link>
                        <a class="dropdown-item" :href="$demoUrl" target="_blank" rel="noopener noreferrer">
                            <i class="fas fa-calendar" aria-hidden="true" />{{ $t('labels.book_a_demo') }}
                        </a>
                        <router-link class="dropdown-item" :to="{ name: 'agencies' }">
                            <i class="fas fa-briefcase" aria-hidden="true" />{{ $t('labels.agencies') }}
                        </router-link>
                        <a class="dropdown-item" :href="$docsUrl" target="_blank">
                            <i class="fas fa-book" aria-hidden="true" />{{ $t('labels.documentation') }}
                        </a>
                        <router-link class="dropdown-item" :to="{ name: 'login' }">
                            <i class="fas fa-right-to-bracket" aria-hidden="true" />{{ $t('labels.log_in') }}
                        </router-link>
                        <router-link class="dropdown-item" :to="{ name: 'contact' }">
                            <i class="fas fa-envelope" aria-hidden="true" />{{ $t('labels.contact_us') }}
                        </router-link>
                    </v-hamburger>
                </div>

                <div v-if="!apiKey && agency" class="d-flex align-items-center justify-content-end">
                    <div class="nav">
                        <div class="nav-item">
                            <v-dropdown-lang />
                        </div>
                    </div>
                </div>

            </div>
        </header>

    </div>

</template>

<style scoped lang="scss">

    .header {
        background: $color-white;
        border-bottom: 1px solid $color-rule-light;
        box-shadow: 0 1px 2px rgba(0,0,0,0.2);
        height: 60px;
        left: 0;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 100;
        .header-inner {
            align-items: center;
            display: flex;
            height: 100%;
            justify-content: space-between;
        }
        .nav {
            align-items: center;
            .nav-item {
                @include font-semibold(12px);
                margin: 0;
                padding: 0;
            }
            .nav-link {
                align-items: center;
                color: $color-text;
                display: flex;
                justify-content: center;
                height: 40px;
                margin: 0;
                padding: 0 10px;
                transition: background-color .3s, color .3s, opacity .3s;
                &:hover, &.active {
                    color: $color-primary;
                }
                &.soft {
                    background: $color-primary-light;
                    border-radius: 5px;
                    color: $color-primary;
                    margin-left: 10px;
                    padding: 10px 15px;
                    &:hover, &.active {
                        background: $color-primary-light;
                        color: $color-primary;
                        opacity: 0.9;
                    }
                }
                &.accent {
                    background: $color-primary;
                    border-radius: 5px;
                    color: $color-white;
                    margin-left: 10px;
                    padding: 10px 15px;
                    &:hover {
                        background: $color-primary;
                        color: $color-white;
                        opacity: 0.9;
                    }
                }
            }
        }
    }

    .logo {
        align-items: center;
        text-decoration: none;
        transition: opacity .3s;
        &:hover {
            opacity: 0.7;
        }
        > img {
            height: 50px;
            width: auto;
            @media (max-width: map-get($grid-breakpoints, 'md')) {
                height: 36px;
            }
        }
        span {
            @include font-semibold(16px);
            line-height: normal;
            @media (max-width: map-get($grid-breakpoints, 'md')) {
                font-size: 14px;
            }
        }
    }

</style>

<script>

import DropdownLang from '@cmp/DropdownLang';
import DropdownUser from '@cmp/DropdownUser';
import Hamburger from '@cmp/Hamburger';

export default {

    components: {
        'v-dropdown-lang': DropdownLang,
        'v-dropdown-user': DropdownUser,
        'v-hamburger': Hamburger,
    },

    computed: {

        loading() {
            return this.$store.getters.loading;
        },

        isHome() {
            return this.$route.name === 'home';
        },

        apiKey() {
            return this.$store.getters.apiKey;
        },

        agency() {
            return this.$store.getters.agency;
        },

        agencyName() {
            return this.agency?.name;
        },

        agencyIcon() {
            return this.agency?.icon?.link;
        },

    },

}

</script>
